export default {
    base: 44,
    small: 28,
    medium: 44,
    large: 56,
};
